import React, { Fragment } from 'react';
import PublicEnergyConsultationForm from '../../components/energy-consultation/PublicEnergyConsultationForm';
import Helmet from 'react-helmet';
import { navigate } from '@reach/router';

const EnergyConsultationPublicForm = () => {
  const isBrowser = !(typeof window === 'undefined');
  const isNotAnIframe = isBrowser && window.parent.location === window.location;
  isNotAnIframe && navigate('/');

  return (
    <Fragment>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>

      <PublicEnergyConsultationForm />
    </Fragment>
  );
};

export default EnergyConsultationPublicForm;
